import React from 'react'

import { LgySubsection } from 'app/components/util/lgy-section/LgySection'
import { formatDollars, formatPhone } from '../common/AssignmentUtils'

const OtherInformationSection = ({ assignmentDetails }) =>
  <LgySubsection header='Other Information' className='assignment-details-child'>
    <div className='usa-width-one-half'>
      <table>
      <caption>Point of Contact (POC) Information</caption>
      <caption>Lender POC</caption>
        <tbody>
          <tr>
            <th scope='row'>POC name:</th>
            <td>{assignmentDetails.pocName}</td>
          </tr>
          <tr>
            <th scope='row'>POC phone number:</th>
            <td>{formatPhone(assignmentDetails.pocPhone)}</td>
          </tr>
          <tr>
            <th scope='row'>POC email:</th>
            <td>{assignmentDetails.pocEmail}</td>
          </tr>
          </tbody>
      </table>
      {(assignmentDetails.appraisalCode === 'LAPP' || assignmentDetails.appraisalCode === 'IND'
        || assignmentDetails.appraisalCode === 'NADL') && 
      <table>
      <caption>Buyer Agent POC</caption>
        <tbody>
          <tr>
            <th scope='row'>POC name:</th>
            <td>{assignmentDetails.buyerAgentPocName}</td>
          </tr>
          <tr>
            <th scope='row'>POC phone number:</th>
            <td>{formatPhone(assignmentDetails.buyerAgentPocPhone)}</td>
          </tr>
          <tr>
            <th scope='row'>POC email:</th>
            <td>{assignmentDetails.buyerAgentPocEmail}</td>
          </tr>
          </tbody>
      </table>}
      <table>
        <tbody>
          <tr>
            <th scope='row'>Annual real estate taxes:</th>
            <td>${formatDollars(assignmentDetails.annualTaxAmount)}</td>
          </tr>
          <tr>
            <th scope='row'>Are mineral rights reserved?</th>
            <td>{assignmentDetails.mineralRightsReserved}</td>
          </tr>
          <tr>
            <th scope='row'>Mineral rights explanation:</th>
            <td>{assignmentDetails.mineralRightsReservedText}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div className='usa-width-one-half'>
      {(assignmentDetails.appraisalCode === 'LAPP' || assignmentDetails.appraisalCode === 'IND'
        || assignmentDetails.appraisalCode === 'NADL') &&
      <table>
      <caption>Tidewater POC</caption>
        <tbody>
          <tr>
            <th scope='row'>POC name:</th>
            <td>{assignmentDetails.tidewaterPocName}</td>
          </tr>
          <tr>
            <th scope='row'>POC phone number:</th>
            <td>{formatPhone(assignmentDetails.tidewaterPocPhone)}</td>
          </tr>
          <tr>
            <th scope='row'>POC email:</th>
            <td>{assignmentDetails.tidewaterPocEmail}</td>
          </tr>
          </tbody>
      </table>}
      {(assignmentDetails.appraisalCode === 'LAPP' || assignmentDetails.appraisalCode === 'IND'
        || assignmentDetails.appraisalCode === 'NADL') &&
      <table>
      <caption>Seller Agent POC</caption>
        <tbody>
          <tr>
            <th scope='row'>POC name:</th>
            <td>{assignmentDetails.sellerAgentPocName}</td>
          </tr>
          <tr>
            <th scope='row'>POC phone number:</th>
            <td>{formatPhone(assignmentDetails.sellerAgentPocPhone)}</td>
          </tr>
          <tr>
            <th scope='row'>POC email:</th>
            <td>{assignmentDetails.sellerAgentPocEmail}</td>
          </tr>
          </tbody>
      </table>}
      <table>
        <caption>Leasehold Cases (if applicable)</caption>
        <tbody>
          <tr>
            <th scope='row'>Lease is:</th>
            <td>{assignmentDetails.leaseType}</td>
          </tr>
          <tr>
            <th scope='row'>Lease expiration date:</th>
            <td>{assignmentDetails.leaseExpirationDate}</td>
          </tr>
          <tr>
            <th scope='row'>Annual ground rent:</th>
            <td>${formatDollars(assignmentDetails.annualRentAmount)}</td>
          </tr>
          <tr>
            <th scope='row'>Occupant phone number:</th>
            <td>{formatPhone(assignmentDetails.occupantPhoneNumber)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </LgySubsection>

export default OtherInformationSection
